module.exports = __webpack_public_path__ + "static/favicon-196-84ebf1b0e758d6f1f0f8ddda5f6ec57b.png";